import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight, Home } from "lucide-react";
import { Button } from "../ui/button";
import { SUCCESS } from "../../constants/testIds";

export function ThankYou({ leadId, onClose, onExplore, compact = false }) {
	return (
		<motion.div
			data-testid={SUCCESS.screen}
			initial={{ opacity: 0, scale: 0.96 }}
			animate={{ opacity: 1, scale: 1 }}
			transition={{ duration: 0.4 }}
			className={`text-center ${compact ? "py-8" : "py-12"} px-6 flex flex-col items-center`}
		>
			<div data-testid={SUCCESS.checkmark} className="mb-6">
				<svg width="88" height="88" viewBox="0 0 52 52" className="mx-auto">
					<circle
						className="check-circle"
						cx="26" cy="26" r="24"
						fill="none"
						stroke="hsl(var(--primary))"
						strokeWidth="3"
					/>
					<path
						className="check-tick"
						fill="none"
						stroke="hsl(var(--primary))"
						strokeWidth="4"
						strokeLinecap="round"
						strokeLinejoin="round"
						d="M14 27 l8 8 l16 -18"
					/>
				</svg>
			</div>

			<h2 className="font-heading text-3xl sm:text-4xl font-extrabold text-slate-900 dark:text-white">
				Thank You!
			</h2>
			<p className="mt-4 text-base sm:text-lg text-slate-600 dark:text-slate-300 max-w-md">
				Your request has been received successfully. Our School Growth Expert will contact you shortly.
			</p>

			{leadId && (
				<p className="mt-4 font-mono-sx text-xs text-slate-400 dark:text-slate-500">
					Reference: {leadId}
				</p>
			)}

			<div className="mt-8 flex flex-col sm:flex-row gap-3">
				{onExplore && (
					<Button
						variant="outline"
						onClick={onExplore}
						className="rounded-full"
						data-testid="thank-you-explore-button"
					>
						Explore Services <ArrowRight className="ml-2 h-4 w-4" />
					</Button>
				)}
				<Button
					onClick={onClose}
					data-testid={SUCCESS.close}
					className="rounded-full bg-emerald-600 hover:bg-emerald-500 text-white"
				>
					<Home className="mr-2 h-4 w-4" /> Back Home
				</Button>
			</div>

			<div className="mt-8 flex items-center gap-2 text-xs text-slate-400 dark:text-slate-500">
				<CheckCircle2 className="h-3.5 w-3.5 text-emerald-500" />
				100% confidential — your details are never shared.
			</div>
		</motion.div>
	);
}
